import toast from "react-hot-toast";
import { useEffect, useState } from "react";
//
import {
    useFetchAllSchemeMutation,
    useSchemeUserSearchMutation,
} from "../../../features/tenant/scheme/schemeApi";
//
import CustomExport from "../../../components/CustomExport/CustomExport";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useFetchProductsMutation } from "../../../features/tenant/products/productsApi";
import SelectComponentWithSearch from "../../../components/Tenant/SelectComponentWIthSearch/SelectComponentWithSearch";
import TenantSlugs from "../../../utils/TenantSlug";

let inputClass =
    "block w-full pl-2 pr-3 border border-gray-300 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors";

const SchemeScanningHistory = () => {
    const initialFilters = {
        mobile: "",
        user_id: "",
        scheme: "all",
        product_code: "",
        batch_running_code: "",
        start_date: "",
        end_date: "",
    };

    const is_aqualite =
        JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
        TenantSlugs["aqualite"];
    const is_lancer = JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs["lancer"];

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [allData, setAllData] = useState([]);
    const [csvData, setCsvData] = useState(null);
    const [request, setRequest] = useState(initialFilters);
    const [paginationData, setPaginationData] = useState({
        total_items: 0,
        current_page: 1,
        limit: 10,
        total_pages: 0,
    });

    const [
        fetchUserSearchApi,
        { data: userSearchData, error: userSearchError },
    ] = useSchemeUserSearchMutation();

    const [
        fetchUserSearchCSVApi,
        { data: userSearchCSVData, error: userSearchCSVError },
    ] = useSchemeUserSearchMutation();

    const [fetchProductsApi, { data: productsData, error: productsError }] =
        useFetchProductsMutation();
    const [fetchSchemesApi, { data: schemesData, error: schemesError }] =
        useFetchAllSchemeMutation();

    const handleSearch = async (body) => {
        toast.loading("Please wait");

        await fetchUserSearchApi({
            token: sessionStorage.getItem("access_token"),
            slug: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: body,
        });

        toast.dismiss();
    };

    const handleFetchSchemeScanningHistoryForCsv = async () => {
        const newRequest = { ...request };
        newRequest["limit"] = 9999999;
        newRequest["page"] = 1;

        fetchUserSearchCSVApi({
            token: sessionStorage.getItem("access_token"),
            slug: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: newRequest,
        });
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
        handleSearch({
            ...request,
            page: pageNumber,
            limit,
        });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        handleSearch({
            ...request,
            page: 1,
            limit: newPerPage,
        });
    };

    const intialize = async () => {
        toast.loading("Please wait");

        await fetchSchemesApi({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
        });

        toast.dismiss("Please wait");

        await handleSearch({
            ...request,
            page,
            limit,
        });
    };

    useEffect(() => {
        if (userSearchCSVData) {
            toast.dismiss();
            setCsvData(
                userSearchCSVData?.body?.list
                    ? userSearchCSVData?.body?.list
                    : []
            );
        }

        if (userSearchCSVError) {
            toast.dismiss();
            toast.error(userSearchCSVError.data.message, {
                id: "userSearchCSVError",
            });
        }
    }, [userSearchCSVData, userSearchCSVError]);

    useEffect(() => {
        if (userSearchData) {
            toast.dismiss();

            setAllData(
                userSearchData?.body?.list ? userSearchData?.body?.list : []
            );

            setPaginationData(
                userSearchData?.body?.pagination
                    ? userSearchData?.body?.pagination
                    : {}
            );
        }
        if (userSearchError) {
            toast.dismiss();
            toast.error(userSearchError.data.message, {
                id: "userSearchError",
            });
        }
    }, [userSearchData, userSearchError]);

    useEffect(() => {
        intialize();
    }, []);

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => (page - 1) * limit + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Scheme",
            cell: (row) => <strong>{row.scheme_name}</strong>,
            sortable: true,
            width: "180px",
        },
        {
            name: "Name",
            cell: (row) => row.user_name,
            sortable: true,
            width: "180px",
        },
        {
            name: "Mobile",
            cell: (row) => row.user_mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "City",
            cell: (row) => row.city,
            sortable: true,
            width: "120px",
        },
        {
            name: "District",
            cell: (row) => row.district,
            sortable: true,
            width: "120px",
        },
        {
            name: "State",
            cell: (row) => row.state,
            sortable: true,
            width: "120px",
        },
        {
            name: "Firm Name",
            cell: (row) => row.firm_name,
            sortable: true,
            width: "140px",
        },
        {
            name: "Product Code",
            cell: (row) => row.product_code,
            sortable: true,
            width: "180px",
        },
         ...(is_lancer
            ? [
                  {
                      name: "Scratch Code",
                      cell: (row) => row.scratch_code || "N/A",
                      sortable: true,
                      width: "180px",
                  },
              ]
            : []),
        {
            name: "Batch Running Code",
            cell: (row) => row.batch_running_code,
            sortable: true,
            width: "180px",
        },
        {
            name: is_aqualite ? "Points/WSP" : "Points",
            cell: (row) => <strong>{row.points}</strong>,
            sortable: true,
            width: "140px",
        },
        {
            name: "MRP",
            cell: (row) => row.mrp,
            sortable: true,
        },
        {
            name: "Created At",
            cell: (row) => new Date(row.created_at).toLocaleString("en-IN", {
                timeZone: "UTC",
            }),
            sortable: true,
            width: "180px",
        },
    ];

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Scheme User Search
                        <LinksComponent />
                    </div>

                    <div className="p-3">
                        <div className="mb-3">
                            <CustomExport
                                fetchData={handleFetchSchemeScanningHistoryForCsv}
                                data={csvData}
                                defaultColumnExport={[
                                    "entity_id",
                                    "template_type",
                                    "template_text",
                                    "receiver_mobile_numbers",
                                    "response_message",
                                    "scheme_name",
                                    "user_name",
                                    "user_mobile",
                                    "city",
                                    "district",
                                    "state",
                                    "firm_name",
                                    "product_code",
                                    "batch_running_code",
                                    "points",
                                     ...(is_lancer ? ["scratch_code"] : []),
                                    "mrp",
                                    "created_at",
                                ]}
                                filename="scheme_scanning_history"
                            />
                        </div>

                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <form
                                className="flex flex-row gap-4 w-full items-end justify-center p-2"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    setPage(1);
                                    handleSearch({
                                        ...request,
                                        page: 1,
                                        limit,
                                    });
                                }}
                            >
                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Mobile
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Mobile ..."
                                        value={request.mobile}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    mobile: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        User ID
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="User ID ..."
                                        value={request.user_id}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    user_id: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Product Code
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Product Code..."
                                        value={request.product_code}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    product_code: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>
                            
                                {/* Scratch Code input for Lancer only */}
                                {is_lancer && (
                                    <div className="relative searchin w-full">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Scratch Code
                                        </label>
                                        <input
                                            type="text"
                                            id="default-search"
                                            className={`${inputClass}`}
                                            placeholder="Scratch Code..."
                                            value={request.scratch_code}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => ({
                                                    ...prevState,
                                                    scratch_code: newValue,
                                                }));
                                            }}
                                        />
                                    </div>
                                )}

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Batch Running Code
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Batch Running Code..."
                                        value={request.batch_running_code}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    batch_running_code: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="space-y-2 w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Scheme
                                    </label>

                                    <select
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Scheme..."
                                        value={request.scheme}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    scheme: newValue,
                                                };
                                            });
                                        }}
                                    >
                                        <option value="all">All Schemes</option>
                                        {schemesData?.body?.data?.map(
                                            (item) => {
                                                return (
                                                    <option value={item.id}>
                                                        {item.name}
                                                    </option>
                                                );
                                            }
                                        )}
                                    </select>
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Start Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Start Date ..."
                                        value={request.start_date}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    start_date: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        End Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="End Date ..."
                                        value={request.end_date}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    end_date: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin">
                                    <button
                                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                        type="submit"
                                    >
                                        <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                            />
                                        </svg>
                                        Search
                                    </button>
                                </div>
                            </form>

                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                data={allData}
                                // loading={loading}
                                totalRows={paginationData?.total_items}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                            >
                                <div className="flex m-2 space-x-2 justify-end"></div>
                            </DataTableComponent>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SchemeScanningHistory;
